import { useClubContact } from '../data/hooks';
import { TENANT_CONTACT_FIELDS, type ClubContact } from '@fsv/data';
import { tx } from '@fsv/data';
import { ErrorState, Loading } from './states';
import { PrivacyStatement } from '../legal/LegalText';

/**
 * Kept as the shared entry point for the privacy text: the operator's full
 * statement (legal/texts.ts), which names the club as the responsible party.
 */
export function PrivacyText() {
  return <PrivacyStatement />;
}

/** The club's own data, as its admins entered them (Verwaltung → Verein). */
export function ClubContactBlock({ contact }: { contact: ClubContact }) {
  const rows = TENANT_CONTACT_FIELDS.map((k) => [k, contact[k]] as const).filter((r): r is readonly [(typeof r)[0], string] => Boolean(r[1]));
  return (
    <section className="panel" aria-labelledby="privacy-club-h">
      <h2 id="privacy-club-h">{tx.privacy.clubTitle}</h2>
      <p>
        <strong>{contact.clubName ?? contact.name}</strong>
      </p>
      {rows.length === 0 ? (
        <p className="muted">{tx.privacy.clubNone}</p>
      ) : (
        <dl className="privacy__club">
          {rows
            .filter(([k]) => k !== 'clubName')
            .map(([k, v]) => (
              <div key={k}>
                <dt className="label">{tx.tenant.fields[k]}</dt>
                <dd>{k === 'website' ? <a href={v} rel="noopener noreferrer">{v}</a> : k === 'contactEmail' ? <a href={`mailto:${v}`}>{v}</a> : v}</dd>
              </div>
            ))}
        </dl>
      )}
    </section>
  );
}

/** /v/<slug>/datenschutz: the same text, plus the active club as the responsible party. */
export function TenantPrivacyScreen() {
  const contact = useClubContact();
  return (
    <div className="page page--narrow privacy stack">
      {contact.isPending ? <Loading /> : contact.isError ? <ErrorState error={contact.error} /> : <ClubContactBlock contact={contact.data} />}
      <PrivacyText />
    </div>
  );
}
